<div class="main p-[1rem] flex flex-row justify-between items-center gap-[0.25rem]">
  <div class="gap-[0.5rem] w-[69%] flex flex-row items-center justify-start">
    @if (!buttons.confirm) {
      <app-selector
        data-qa="fs-model-selector"
        class="w-[100%]"
        [data]="data"
        [selectedItem]="selectedItem"
        [selectedItemStyle]="modelSelectedItemStyle"
        [itemTextField]="'lastSaveText'"
        [maxLengthSelectedItem]="45"
        [textClass]="'main-8 bold600'"
        [field]="'name'"
        (itemEmitter)="modelChanged($event)">
      </app-selector>
    }
    @if (show.input && buttons.confirm) {
      <app-input class="w-[100%]"
        data-qa="fs-model-input-name"
        [input]="input"
        [autofocus]="true"
        [additionalClass]="isNameEmpty ? 'error' : ''"
        [placeholder]="'Type model name here'"
        (inputChange)="inputChangeEmitter($event)">
      </app-input>
    }
  </div>
  <div class="flex justify-end items-center gap-[0.375rem] w-[50%]">
    @if (!buttons.confirm && data?.length) {
      <div
        class="flex flex-row items-center justify-center gap-[0.375rem]">
        <div class="gap-[0.375rem] flex">
          <app-button
            data-qa="fs-delete-model"
            [size]="'small'"
            [type]="'grey-white'"
            [iconName]="'delete.svg'"
            (buttonClick)="deleteModel()">
            Delete
          </app-button>
          <app-button
            data-qa="fs-duplicate-model"
            [size]="'small'"
            [type]="'grey-white'"
            [iconName]="'copy-outline.svg'"
            (buttonClick)="buttonClicked.emit(editStatus.copyModel)">
            Duplicate
          </app-button>
          <app-button
            data-qa="fs-export-excel-button"
            class="flex-none"
            [size]="'small'"
            [type]="'grey-white'"
            [iconName]="'excel.svg'"
            (buttonClick)="exportExcelEmitter.emit()">
            Export
          </app-button>
          <app-button
            data-qa="fs-rename-model"
            [size]="'small'"
            [type]="'grey-white'"
            [iconName]="'edit-outline.svg'"
            (buttonClick)="renameModel()">
            Rename
          </app-button>
        </div>
        <app-button
          class="flex00auto"
          data-qa="fs-add-model"
          [type]="'accent'"
          [size]="'small'"
          [iconName]="'plus.svg'"
          (click)="addNewModelClicked()">
          New model
        </app-button>
      </div>
    }

    @if (buttons.confirm) {
      <div class="flex flex-row items-center justify-start gap-[0.5rem]">
        @if (buttons.decline) {
          <app-button
            data-qa="fs-cancel-button"
            [size]="'small'"
            (click)="declineClicked()">
            Cancel
          </app-button>
        }
        @if (buttons.confirm && !buttons.rename) {
          <app-button
            data-qa="fs-apply-button"
            [disabled]="!input || isNameEmpty"
            [size]="'small'"
            [type]="'accent'"
            (buttonClick)="confirmClicked()">
            Save
          </app-button>
        }
        @if (buttons.rename) {
          <app-button
            data-qa="fs-apply-button"
            [disabled]="isNameEmpty"
            [size]="'small'"
            [type]="'accent'"
            (buttonClick)="confirmRename()">
            Rename
          </app-button>
        }
      </div>
    }
  </div>
</div>
@if (show.modalThinkTwice) {
  <app-modal-dialog
    [header]="'Delete model'"
    [useStandardList]="false"
    [mainText]="deleteModalTextList"
    [addAdditionalText]="true"
    (isConfirmed)="closeModalDeleteModel($event)">
  </app-modal-dialog>
}
